// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Appliquer',
    back: 'Retour aux messages',
    cancel: 'Annuler',
    comment: 'Commenter',
    commented_on_image: 'a commenté l\'image',
    comments: 'Commentaires',
    delete: 'Supprimer',
    delete_comment: 'Supprimer ce commentaire ?',
    deleted_image: 'L\'image a été supprimée',
    download: 'Télécharger l\'image',
    edit: 'Modifier',
    no_comment: 'Aucun commentaire à afficher',
    write_comment: 'Écrivez votre commentaire',
};
